// extracted by mini-css-extract-plugin
export default {"container":"loading_container__kNVPz","loading-animation":"loading_loading-animation__MPba8","rect":"loading_rect__mi1B3","img":"loading_img__EcY+I"};